var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationNoteApproveEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F7F2FD64-57BA-4FD1-A618-1B176FF44E64") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-Feed-Left",
    transform: "translate(-602.000000, -2100.000000)",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(24.000000, 2070.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions",
    transform: "translate(576.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-approve",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,20.0001464 L2,3.99985364 C2,2.89484758 2.89317632,2 3.99985364,2 L20.0001464,2 C21.1051524,2 22,2.89317632 22,3.99985364 L22,20.0001464 C22,21.1051524 21.1068237,22 20.0001464,22 L3.99985364,22 C2.89484758,22 2,21.1068237 2,20.0001464 Z M20.0001464,4 L4,3.99985364 L3.99985364,20 L20,20.0001464 L20.0001464,4 Z M9.79289322,15.7071068 L6.79289322,12.7071068 C6.40236893,12.3165825 6.40236893,11.6834175 6.79289322,11.2928932 C7.18341751,10.9023689 7.81658249,10.9023689 8.20710678,11.2928932 L10.5,13.5998695 L15.2928932,8.79289322 C15.6834175,8.40236893 16.3165825,8.40236893 16.7071068,8.79289322 C17.0976311,9.18341751 17.0976311,9.81658249 16.7071068,10.2071068 L11.2071068,15.7071068 C10.8165825,16.0976311 10.1834175,16.0976311 9.79289322,15.7071068 Z",
    id: "Combined-Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationNoteApproveEmpty);
export default __webpack_public_path__ + "static/media/application_note_approve_empty.fa26776760bb93402e28603d84c3b233.svg";
export { ForwardRef as ReactComponent };